<template>
  <div class="flex column" style="width: 100vm" v-title data-title="其他问题">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
<!--          <span v-if="index === list.length - 1">{{index + 1}}.{{data.title}}<a href="tel:029-89875100">029-89875100</a></span>-->
<!--          <span v-else>{{index + 1}}.{{data.title}}</span>-->
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutOther",
    data () {
      return{
        list: [
          {
            title: '如何邀请其他教师使用阅伴App？',
            detailTexts: [{title: '打开阅伴教师端App，在首页点击“邀请老师”按钮，选择分享方式进行邀请。邀请的教师注册并认证成功后，可获得阅芽奖励。'}]
          },
          {
            title: '如何修改头像、姓名、性别、生日、城市、学校、密码？',
            detailTexts: [{title: '点击“我的”页面，下滑至底部，选择“设置”进入设置页，选择“修改个人信息”，可修改个人信息。'},
              {title: '选择“修改密码”，通过输入手机号和验证码，可以修改密码。'}]
          },
          {
            title: '如何修改我的登录手机号？',
            detailTexts: [{title: '点击“我的”页面，下滑至底部，选择“设置”进入设置页，选择“修改手机号”，根据流程操作即可修改手机号。'}]
          },
          {
            title: '为什么班级里面的学生会出现重复的情况？',
            detailTexts: [{title: '第1种情况，班级里有同名同姓的学生；'},{title: '第2中情况，同一个学生的几位家长都注册了账号，并以孩子的姓名加入了班级。'}]
          },
          {
            title: '为什么学生闯关成功以后字数没有增加？',
            detailTexts: [{title: '只有成功闯完一本书的所有关卡以后，阅读字数才会增加。'}]
          },
          {
            title: '为什么学生读的书中找不到闯关的答案？',
            detailTexts: [{title: '请确认阅读的纸质书与阅伴闯关书籍版本是否一致。'}]
          },
          {
            title: '为什么阅伴App找不到我想要闯关的书？',
            detailTexts: [{title: '1.阅伴APP顶部有搜索功能，使用书目搜索查找书籍；'},
              {title: '2.如果搜索不到书籍，可通过“缺书推荐”功能，向阅伴推荐你要闯关的书籍。'}]
          },
          {
            title: '手机不能获取验证码怎么办？',
            detailTexts: [{title: '阅伴App支持两种登录方式，一是手机号和短信验证码登录，二是手机号和密码的登录方式。如果遇到不方便接收验证码的情况下，可以使用密码登录（所以，一定要记得注册时设置的登录密码）。'}]
          },
          {
            title: '阅伴App为什么不能看书？',
            detailTexts: [{title: '您好，阅伴App目前仅提供闯关功能，如果想读书建议您在阅伴书店购买正版纸质书哦，购书还可以获得阅芽等奖励。'}]
          },
          {
            title: '为什么找不到自己的学校？',
            detailTexts: [{title: '您好，如果发现没有您自己的学校，您可以拨打电话联系我们。联系方式：'}]
          },
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutOther.vue